// @flow
import React, {Component} from 'react';
import {ApolloProvider} from 'react-apollo';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader';
import {HelmetProvider} from 'react-helmet-async';

import Application from '../Application/Application';
import ExperimentProvider from '../Experiment/ExperimentProvider';
import IntlWrapper from '../IntlWrapper/IntlWrapper';

import type {Store} from 'redux';
import type {ApolloClient} from 'apollo-client';
import type {State as AbacusState} from '../../reducers/abacus';

export type Props = {
    abacus: AbacusState,
    client: ApolloClient<*>,
    store: Store<*, *>,
    helmetContext: {}
};

class Root extends Component<Props> {
    render() {
        return (
            <HelmetProvider context={this.props.helmetContext}>
                <ApolloProvider client={this.props.client}>
                    <Provider store={this.props.store}>
                        <ExperimentProvider abacus={this.props.abacus}>
                            <IntlWrapper>
                                <Application />
                            </IntlWrapper>
                        </ExperimentProvider>
                    </Provider>
                </ApolloProvider>
            </HelmetProvider>
        );
    }
}

export default hot(module)(Root);
